export const animate = (element, keyframes, options) => element.animate(keyframes, options);
export const scrollIntoView = (element, options) => element.scrollIntoView(options);
